<template>
  <g class="bgCharactersModuleTwo">

    <texter :data="texterData" />

    <dylan :data="dylanData" />

    <g transform="translate(0, 50)">
      <boyFour :data="boyFourData" />
      <girlFour :data="girlFourData" />
      <boyThree :data="boyThreeData" />
      <girlThree :data="girlThreeData" />
      <girlTwo :data="girlTwoData" />
      <boyTwo :data="boyTwoData" />
    </g>

    <boyOne :data="boyOneData" />
    <girlOne :data="girlOneData" />

  </g>
</template>


<script>
  import texter from './texter'
  import boyFour from './boyFour'
  import girlFour from './girlFour'
  import boyThree from './boyThree'
  import girlThree from './girlThree'
  import girlTwo from './girlTwo'
  import boyTwo from './boyTwo'
  import boyOne from './boyOne'
  import girlOne from './girlOne'
  import dylan from './dylan'

  import {
    characterSpeech
  } from '@/assets/js/utils/characterSpeech'

  const defaults = {
    blinking: false,
    speaking: false,
    headRotate: false,
    armRaised: true
  }

  export default {
    data() {
      return {
        texterData: { ...defaults
        },
        boyFourData: { ...defaults
        },
        girlFourData: { ...defaults
        },
        boyThreeData: { ...defaults
        },
        girlThreeData: { ...defaults
        },
        girlTwoData: { ...defaults
        },
        boyTwoData: { ...defaults
        },
        boyOneData: { ...defaults
        },
        girlOneData: { ...defaults
        },
        dylanData: {...defaults}
      }
    },
    components: {
      texter,
      boyFour,
      girlFour,
      boyThree,
      girlThree,
      girlTwo,
      boyTwo,
      boyOne,
      girlOne,
      dylan
    },
    mounted() {

      // copypaste from module 3
      const characters = [{
          data: this.texterData
        },
        {
          data: this.boyFourData
        },
        {
          data: this.girlFourData
        },
        {
          data: this.boyThreeData
        },
        {
          data: this.girlThreeData
        },
        {
          data: this.girlTwoData
        },
        {
          data: this.boyTwoData
        },
        {
          data: this.boyOneData
        },
        {
          data: this.girlOneData
        },
        {
          data: this.dylanData
        }
      ]

      // random number generator
      const generateRandom = (min, max) => {
        return Math.random() * (max - min) + min;
      }

      // blinking animation
      const createBlinkAnimation = (data) => {
        setInterval(() => {
          data.blinking = true
          setTimeout(() => {
            data.blinking = false
          }, 300)
        }, generateRandom(6000, 8000)) // make random number
      }

      // speaking animation
      const createSpeakingAnimation = (data, callback) => {
        callback = callback || function () {}
        setInterval(() => {
          characterSpeech(data, generateRandom(2, 5))
          if (generateRandom(-1, 1) > 0) { // fire callback (arm raise) half of the time
            callback()
          }
        }, generateRandom(6000, 8000)) // generateRandom(6000, 8000)
      }

      // head rotate animation
      const createHeadRotateAnimation = (data) => {
        setInterval(() => {
          data.headRotate = true
          setTimeout(() => {
            data.headRotate = false
          }, generateRandom(4000, 5600))
        }, generateRandom(10000, 12000))
      }

      // init animations
      for (let i = 0; i < characters.length; i++) {
        setTimeout(() => {
          createBlinkAnimation(characters[i].data)
          createSpeakingAnimation(characters[i].data, characters[i].callback)
          createHeadRotateAnimation(characters[i].data)
        }, generateRandom(0, 2000))
      }

    }
  }

</script>

<style lang="scss">
  @import './bgCharacters';

</style>



// WEBPACK FOOTER //
// backgroundCharacters.vue?24e59b4c